import IMemberUserRepository from "../../../domain/interfaces/repositories/IMemberUserRepository";
import {
    SetClassificationMemberUserCommandRequest
} from '../../../domain/entities/memberUser'

export const SetClassificationMemberUserCommand = (repository: IMemberUserRepository, data: SetClassificationMemberUserCommandRequest)=>{
    return repository.setClassification(data)
}
